import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import './Modal-Form.css'
import emlyLogo from '../../../images/LOGO.png';

class PopUp extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const {
      title,
      buttonLabel,
      children,
      onExecution,
      onCancel,
      type,
      bottomButton = true,
      bottomButtonCancel = true,
      loadingCancel = false,
      bottonLabelCencel = 'Cancel',
      disabled = false,
      link = null,
      topWidth = false,
      width = '70%',
      fullScreen,
      appstore,
      className = null,
      showScroll = true
    } = this.props
    const label = type === 'danger' ? (buttonLabel ? buttonLabel : 'Delete') : buttonLabel

    return (
      <React.Fragment>
        <div
          className={`popupMainContainer model-space ${appstore ? 'appStore-create' : ''}  ${className !== undefined || className !== null ? className : ''
            }`}
        >
          <div className='if-full-screen'>{fullScreen}</div>
          {className === "surveyPopUp" &&
            <div className="_survey-logo">
              <span className="_survey-logo-mark">
                <img src={emlyLogo} alt="EmlyLabs logo" />
              </span>
            </div>
          }
          <div
            className="popup-content"
            data-theme={
              this.props.theme && this.props.theme.action && this.props.theme.action.theme
                ? this.props.theme.action.theme
                : 'light'
            }
          >
            <div
              style={{ width: width, marginTop: topWidth ? 50 : 0 }}
              className={
                type === 'danger' ? 'popupMainContainer-all-content danger' : 'popupMainContainer-all-content success'
              }
            >
              <div className="modalHeader" style={{ backgroundColor: '#ffffff' }}>
                {!loadingCancel && (
                  <div className="header-icons">
                    <button className="close-button" onClick={onCancel} aria-hidden="true" aria-label="Close">
                      <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                  </div>
                )}
              </div>
              <>
                <div className={`mp-content ${showScroll ? 'em-scroll' : ''}`}>
                  {title && <h3 className="currentOrg">{title}</h3>}
                  {children}
                </div>
                {bottomButton || bottomButtonCancel ? (
                  <div className={bottomButtonCancel ? 'modalFooter' : 'modalFooter-1'}>
                    {bottomButton && (
                      <button
                        className={disabled ? 'disabledInvite' : type === 'danger' ? 'dangerInvite' : 'successInvite'}
                        id={bottomButtonCancel ? 'invite-user' : 'invite-user-1'}
                        onClick={e => !disabled && onExecution(e)}
                      >
                        {link !== null ? (
                          <Link style={{ color: '#fff' }} to={link}>
                            {label}
                          </Link>
                        ) : (
                          label
                        )}
                      </button>
                    )}
                    {bottomButtonCancel && (
                      <button
                        style={{ color: '#000' }}
                        className={type === 'danger' ? 'dangerCancel' : 'successCancel'}
                        id={'cancel'}
                        onClick={onCancel}
                      >
                        {bottonLabelCencel}
                      </button>
                    )}
                  </div>
                ) : (
                  <></>
                )}
              </>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}
const mapStateToProps = state => ({
  theme: state.theme
})
export default connect(mapStateToProps)(PopUp)
